export const useDateMask = ({ dateFormat, onChange, onKeyUp: onKeyUpProp, onKeyDown: onKeyDownProp }) => {
    const delimiter = dateFormat.match(/\W/)?.[0];
    const segments = dateFormat.split(delimiter);
    const delimiterLocations = [segments[0].length, segments[0].length + 1 + segments[1].length];
    const insertDelimiterAtIndex = (i, value) => value.slice(0, i) + delimiter + value.slice(i);
    const onKeyDown = (e) => {
        const { currentTarget, key, metaKey, ctrlKey } = e;
        const { value, selectionStart } = currentTarget;
        const isCharacter = key.length === 1 && !metaKey && !ctrlKey && key !== " ";
        const isNumber = !isNaN(Number(key));
        const isNonNumericCharacter = isCharacter && !isNumber;
        const isMaxLength = value.length === dateFormat.length;
        const canTypeDelimiter = key === delimiter &&
            selectionStart &&
            delimiterLocations.includes(selectionStart) &&
            value[selectionStart] !== delimiter;
        if (canTypeDelimiter) {
            return;
        }
        const selectionType = window.getSelection()?.type;
        if (isNonNumericCharacter || (isNumber && isMaxLength && selectionType === "Caret")) {
            e.preventDefault();
        }
    };
    const onKeyUp = (e) => {
        const { currentTarget: input, key } = e;
        const { value, selectionStart, selectionEnd } = input;
        const isNumber = !isNaN(Number(key));
        if (selectionStart === null) {
            return;
        }
        if (isNumber && selectionStart === selectionEnd && value[selectionStart] !== delimiter) {
            // Auto-insert delimiters at insertion point
            if (delimiterLocations.includes(selectionStart)) {
                input.value = insertDelimiterAtIndex(selectionStart, value);
                input.selectionStart = selectionStart + 1;
                input.selectionEnd = input.selectionStart;
            }
            /* @ts-expect-error It's ok. The important properties are shared. */
            onChange(e);
            e.preventDefault();
        }
        // If number typed should have delimiter behind it but doesn't, add it
        if (isNumber && delimiterLocations.includes(selectionStart - 1) && value.charAt(selectionStart - 1) !== delimiter) {
            input.value = insertDelimiterAtIndex(selectionStart - 1, value);
            input.selectionStart = selectionStart + 1;
            input.selectionEnd = input.selectionStart;
        }
        // Trim value if longer than max
        if (input.value.length > dateFormat.length) {
            input.value = input.value.slice(0, Math.max(0, dateFormat.length));
            input.selectionStart = selectionStart + 1;
            input.selectionEnd = input.selectionStart;
            /* @ts-expect-error It's ok. The important properties are shared. */
            onChange(e);
            e.preventDefault();
        }
    };
    return {
        onKeyDown: (e) => {
            onKeyDown(e);
            onKeyDownProp?.(e);
        },
        onKeyUp: (e) => {
            onKeyUp(e);
            onKeyUpProp?.(e);
        }
    };
};
